/**
 * Illustration & Calculation State Atoms for Jotai
 */
import { atom } from 'jotai';
import type { CashflowRow } from '../core/calculations';

export interface IllustrationInputState {
  illustrationId?: string;
  productId: string;
  customerName: string;
  customerAge: number;
  customerGender: 'Nam' | 'Nữ';
  customerPhone?: string;
  customerEmail?: string;
  customerDob?: string;
  sumAssured: string;
  term: string;
  freq: string;
  estPremium: string;
  selectedRiders: string[];
  topUpAmount: number;
  topUpStartYear: number;
  topUpDuration: number;
  r5Mode?: 'complimentary' | 'attached';
  r1Package?: 'silver' | 'gold' | 'platinum';
  r2LimitCuoi?: number;
  r2LimitSom?: number;
  r2LimitDacBiet?: number;
  r3DailyAllowance?: number;
  r4PhysicalLimit?: number;
  r5SumAssured?: number;
  r5Term?: '20_years' | 'whole_life';
  riderPremiumOverrides?: Record<string, number>;
}

export const defaultIllustrationInput: IllustrationInputState = {
  productId: 'XUM',
  customerName: 'Hoàng Cao Minh',
  customerAge: 34,
  customerGender: 'Nam',
  customerDob: '24/01/1992',
  customerPhone: '84333233192',
  sumAssured: '1.000.000.000',
  term: '20 năm',
  freq: 'Năm',
  estPremium: '20.000.000',
  selectedRiders: [],
  topUpAmount: 0,
  topUpStartYear: 1,
  topUpDuration: 0,
  r5Mode: 'complimentary',
  r1Package: 'silver',
};

/**
 * Atom holding current illustration inputs (form parameters)
 */
export const illustrationInputAtom = atom<IllustrationInputState>(defaultIllustrationInput);

/**
 * Atom holding computed cashflow table results
 */
export const illustrationResultAtom = atom<CashflowRow[]>([]);
